import React from 'react'
import { cn } from '../../lib/utils'

// Chips de filtro: se ven y se tocan, sin abrir un menu.
//
// Existe porque casi todos los filtros del modulo acabaron siendo <Select>, y un
// select esconde las opciones y su conteo detras de un clic. Para listas cortas y
// conocidas (tallas, tipo de prenda, si/no) los chips dicen de un vistazo que hay y
// que esta activo.
//
// `multiple` decide el comportamiento: sin el, elegir uno apaga los demas.
export const ChipFilter = ({
  opciones = [],
  valor,
  onChange,
  multiple = false,
  ariaLabel,
  scroll = false,
}) => {
  const activos = multiple ? (valor || []) : [valor]

  const toggle = (v) => {
    if (!multiple) {
      onChange(valor === v ? null : v)
      return
    }
    const actual = valor || []
    onChange(actual.includes(v) ? actual.filter((x) => x !== v) : [...actual, v])
  }

  return (
    // `scroll`: una sola fila que se desliza de lado en vez de apilarse. En movil,
    // chips largos (una temporada con su deporte) se comen un renglon cada uno.
    <div
      className={cn(
        'flex gap-1.5',
        scroll
          ? '-mx-1 flex-nowrap overflow-x-auto px-1 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'
          : 'flex-wrap',
      )}
      role="group"
      aria-label={ariaLabel}
    >
      {opciones.map((o) => {
        const activo = activos.includes(o.value)
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={activo}
            onClick={() => toggle(o.value)}
            className={cn(
              'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
              scroll && 'shrink-0 whitespace-nowrap',
              activo
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-input bg-background text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            {o.label}
            {o.count != null && (
              <span className={cn('ml-1.5 tabular-nums', activo ? 'opacity-80' : 'opacity-60')}>
                {o.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default ChipFilter
